import {
  SET_DETAILED_CALCULATION_FOR_RAIL_FREIGHT,
  SET_MULTIMODE_RATE_COMPARISON_COMMODITY_CATEGORY_LIST,
  SET_MULTIMODE_RATE_COMPARISON_FREIGHT_DAYS_LIST,
  SET_MULTIMODE_RATE_COMPARISON_FREIGHT_RATE_LIST,
  SET_MULTIMODE_RATE_COMPARISON_SOURE_DESTINATION_LIST,
  SET_MULTIMODE_RATE_COMPARISON_VEHICLE_DETAILS_LIST,
  SET_MULTIMODE_RATE_COMPARISON_VIEW_DETAILS_RAIL_FREIGHT_RATE_LIST,
  SET_MULTIMODE_RATE_COMPARISON_VIEW_DETAILS_ROAD_FREIGHT_RATE_LIST,
  SET_MULTIMODE_RATE_COMPARISON_WAGON_TYPES_LIST,
  SET_ORIGIN_DESTINATION_YARD_LIST,
  SET_RAIL_RAKE_LIST,
} from "Constants/actionConstants";
import { getItemFromSessionStorage } from "Utils/sessionStorage";

const initialState = {
  source: [],
  destination: [],
  commodityCategories: [],
  roadFreight: [],
  freightDays: [],
  vehicleDetails: [],
  railFreightBcn: [],
  viewDetailsRoadFreight: [],
  viewDetailsRailFreightBcn: [],
  wagonTypes: [],
  railRakeList: [],
  lowestFreight: {},
  detailedCalculationForRailFreight:
    getItemFromSessionStorage("detailedCalculationForRailFreight") || {},
  originYardList: [],
  destinationYardList: [],
};

const rateComparison = (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_MULTIMODE_RATE_COMPARISON_SOURE_DESTINATION_LIST: {
      return {
        ...state,
        source: payload.source,
        destination: payload.destination,
      };
    }
    case SET_MULTIMODE_RATE_COMPARISON_COMMODITY_CATEGORY_LIST: {
      return {
        ...state,
        commodityCategories: payload,
      };
    }
    case SET_MULTIMODE_RATE_COMPARISON_FREIGHT_RATE_LIST: {
      return {
        ...state,
        roadFreight: payload.roadFreight,
        railFreightBcn: payload.railFreightBcn,
        lowestFreight: payload.lowestFreight,
      };
    }
    case SET_MULTIMODE_RATE_COMPARISON_FREIGHT_DAYS_LIST: {
      return {
        ...state,
        freightDays: payload,
      };
    }
    case SET_MULTIMODE_RATE_COMPARISON_VEHICLE_DETAILS_LIST: {
      return {
        ...state,
        vehicleDetails: payload,
      };
    }
    case SET_MULTIMODE_RATE_COMPARISON_VIEW_DETAILS_ROAD_FREIGHT_RATE_LIST: {
      return {
        ...state,
        viewDetailsRoadFreight: payload,
      };
    }
    case SET_MULTIMODE_RATE_COMPARISON_VIEW_DETAILS_RAIL_FREIGHT_RATE_LIST: {
      return {
        ...state,
        viewDetailsRailFreightBcn: payload,
      };
    }
    case SET_MULTIMODE_RATE_COMPARISON_WAGON_TYPES_LIST: {
      return {
        ...state,
        wagonTypes: payload,
      };
    }
    case SET_RAIL_RAKE_LIST: {
      return {
        ...state,
        railRakeList: payload,
      };
    }
    case SET_DETAILED_CALCULATION_FOR_RAIL_FREIGHT: {
      return {
        ...state,
        detailedCalculationForRailFreight: payload,
      };
    }
    case SET_ORIGIN_DESTINATION_YARD_LIST: {
      return {
        ...state,
        originYardList: payload.originYardList,
        destinationYardList: payload.destinationYardList,
      };
    }

    default:
      return state;
  }
};

export default rateComparison;
